import { Content as _Content, Columns } from '#~/common/editor/index.js';
import { Preview } from '../preview/index.js';
import { Details } from './details.jsx';
import { Callout } from '@studio/design-system/callout';
import type { HtmlAttributes } from '@studio/design-system/props';
import { vendorName } from '@studio/design-system/themes/vendor.js';
import type { ReactElement } from 'react';

/** Manufacturer `<Content>` component. */
export const Content = (props: HtmlAttributes): ReactElement => (
  <_Content {...props}>
    <Columns>
      <Columns.Column>
        <h3>Source details</h3>

        <Callout title='Why select a camera model?'>
          <Callout.P>
            By selecting your camera&rsquo;s make and model, {vendorName()} will calibrate your
            camera to enable Auto-Tracking and Magic Movement tools.
          </Callout.P>
        </Callout>

        <Details />
      </Columns.Column>

      <div>
        <h3>Video preview</h3>
        <Preview />
      </div>
    </Columns>
  </_Content>
);
